// ============ i18n Configuration - react-i18next setup ============

import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import commonIt from '../locales/it/common.json';
import authIt from '../locales/it/auth.json';
import schedulerIt from '../locales/it/scheduler.json';
import settingsIt from '../locales/it/settings.json';
import customersIt from '../locales/it/customers.json';
import dashboardIt from '../locales/it/dashboard.json';
import reportsIt from '../locales/it/reports.json';
import errorsIt from '../locales/it/errors.json';
import bookingRequestsIt from '../locales/it/booking-requests.json';
import publicBookingIt from '../locales/it/public-booking.json';

import commonEn from '../locales/en/common.json';
import authEn from '../locales/en/auth.json';
import schedulerEn from '../locales/en/scheduler.json';
import settingsEn from '../locales/en/settings.json';
import customersEn from '../locales/en/customers.json';
import dashboardEn from '../locales/en/dashboard.json';
import reportsEn from '../locales/en/reports.json';
import errorsEn from '../locales/en/errors.json';
import bookingRequestsEn from '../locales/en/booking-requests.json';
import publicBookingEn from '../locales/en/public-booking.json';

export const defaultNS = 'common';
export const resources = {
  it: {
    common: commonIt,
    auth: authIt,
    scheduler: schedulerIt,
    settings: settingsIt,
    customers: customersIt,
    dashboard: dashboardIt,
    reports: reportsIt,
    errors: errorsIt,
    'booking-requests': bookingRequestsIt,
    'public-booking': publicBookingIt,
  },
  en: {
    common: commonEn,
    auth: authEn,
    scheduler: schedulerEn,
    settings: settingsEn,
    customers: customersEn,
    dashboard: dashboardEn,
    reports: reportsEn,
    errors: errorsEn,
    'booking-requests': bookingRequestsEn,
    'public-booking': publicBookingEn,
  },
} as const;

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'it',
    defaultNS,
    ns: ['common', 'auth', 'scheduler', 'settings', 'customers', 'dashboard', 'reports', 'errors', 'booking-requests', 'public-booking'],
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: 'skedulab-language',
      caches: ['localStorage'],
    },
  });

export default i18n;
